module.exports = __webpack_public_path__ + "static/media/status-eye.5bc4e685.svg";